import { AmountSuperScript } from "components/design/AmountSuperScript";
import { Button } from "components/DesignSystem/Button/Button";
import ChatCard from "components/DesignSystem/ChatCard/v2/ChatCard";
import { Cross } from "components/icons/Cross";
import { DISPLAY_DATE } from "constants/date";
import dayjs from "dayjs";
import { motion } from "framer-motion";
import { useAppDispatch } from "hooks/useAppDispatch";
import {
  clearEstimatedTaxCardInChat,
  EstimatedTaxCardInChat as EstimatedTaxCardInChatType,
} from "store/slices/estimatedTaxCardInChat";

export const EstimatedTaxCardInChat = ({
  card,
}: {
  card: EstimatedTaxCardInChatType;
}) => {
  const dispatch = useAppDispatch();
  const showEstimated = card.status !== "PAID" && card.paid_amount === 0;
  const showPaid = card.paid_amount > 0 || card.estimated_payment === 0;

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="t-rounded t-bg-surface-lighter-grey"
    >
      <div className="t-flex t-flex-col t-gap-4 t-w-full t-pb-1.5">
        <ChatCard.Content>
          <ChatCard.Header>
            <div className="t-flex t-justify-between t-items-center">
              <span>
                {card.label} {card.year} Estimated Tax
              </span>
              <Button
                customType="ghost_icon"
                onClick={() => dispatch(clearEstimatedTaxCardInChat())}
              >
                <Cross />
              </Button>
            </div>
          </ChatCard.Header>
          <ChatCard.Body>
            <div className="t-text-body-sm t-text-text-30">
              Due {dayjs(card.deadline).format(DISPLAY_DATE)}
            </div>
            {showEstimated && (
              <div className="t-mt-1">
                <div className="t-text-body-sm t-text-text-30 t-mb-0.5">
                  Estimated
                </div>
                <AmountSuperScript amount={card.estimated_payment ?? 0} />
              </div>
            )}
            {showPaid && (
              <div className="t-mt-1">
                <div className="t-text-body-sm t-text-text-30 t-mb-0.5">
                  Paid
                </div>
                <AmountSuperScript amount={card.paid_amount} />
              </div>
            )}
          </ChatCard.Body>
        </ChatCard.Content>
      </div>
    </motion.div>
  );
};
